import EventsBoard from '~/components/Events/EventsBoard/EventsBoard';
import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import { useTranslation } from 'react-i18next';

import styles from './Events.module.scss';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';

export interface IUserRoles {
  id: number;
  name: string;
  display_name: string;
}

const Events = () => {
  const { t } = useTranslation();

  const roleParams = useMemo(() => {}, []);

  const { data: userRoles } = useQuery<IUserRoles[] | undefined>({
    queryFn: async () => {
      const { data } = await instance.get('admin/get-roles');
      return data;
    },
    queryKey: ['roles', roleParams],
    keepPreviousData: true,
  });

  return (
    <Page heading={<Heading text={t('events')} />}>
      <div className={styles.tabsWrapper}>
        <EventsBoard userRoles={userRoles} />
      </div>
    </Page>
  );
};

export default Events;
